import {Button, Modal, Row, Col} from 'react-bootstrap';
import Slider from "react-slick";

import amenities from "../../data/amenities.json";

function HouseModal(props) {

  const { housesinfo } = props;
  const imagesContext = require.context(
      '../../..',
      true,
      /public\/images\/house\d+\/\d+\.jpg$/
  );

  const roomImages = imagesContext
      .keys()
      .filter(path => path.includes(`/house${housesinfo.id}/`))
      .sort((a, b) => {
        const numA = Number(a.match(/\/(\d+)\.jpg$/)?.[1] || 0);
        const numB = Number(b.match(/\/(\d+)\.jpg$/)?.[1] || 0);
        return numA - numB;
      })
      .map(path => imagesContext(path));

  var settings = {
    customPaging: function(i) {
      return (
          <a>
            <img src={roomImages[i]} alt={`House ${housesinfo.id}, image ${i + 1}`} />
          </a>
      );
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {housesinfo.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={7}>
            <Slider {...settings}>
              {roomImages.map((img, index) => (
                  <div key={index}>
                    <img src={img} alt={housesinfo.title} loading="lazy" />
                  </div>
              ))}
            </Slider>
          </Col>
          <Col md={5}>
            <h4>Description</h4>
            <Col md={12}>
              <p className="mt30 mb10">Price: from <span className="price">{housesinfo.price} €</span> / per night</p>
            </Col>
            <Row>
              <Col sm={6}>
                <span className="size">Room size: 35m2</span>
              </Col>
            </Row>
            <Col md={12}>
              <p className="mb30">Capacity: {housesinfo.capacity}</p>
              <p className="mb30">{housesinfo.description}</p>
            </Col>
          </Col>
        </Row>
        <Row className="mt30">
          {amenities.columns.map((column, index) => (
              <Col sm={4} key={index}>
                <ul className="list">
                  {column.map((item, itemIndex) => (
                      <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </Col>
          ))}
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button href="https://glamping-cy.book.page/" target="_blank" onClick={props.onHide}>Book this house</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default HouseModal;
